import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}




// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripCancellation/actions.js